import { PathOptions } from "leaflet";

// Ocorrências de recursos minerais — Serviço Geológico do Brasil (SGB/CPRM).
// A camada usa um customIcon (picareta) em layers.ts, então este PathOptions
// só é lido para colorir o preview WMS de zoom baixo (RenderGeoServerLayers
// extrai fillColor daqui) — não afeta os marcadores em si.
export const sgb_ocorrencias_recursos_minerais = (): PathOptions => ({
  color: "#212121",
  weight: 1,
  opacity: 1,
  fillColor: "#455A64",
  fillOpacity: 0.8,
});
